import React, { useEffect } from 'react'

export default function CookieBanner() {
	useEffect(() => {
		const scriptSrc =
			'https://app.termly.io/resource-blocker/2c9a72f3-3e71-4589-ac5e-c4b9bb5ead6f?autoBlock=on'

		const existing = document.querySelector(`script[src="${scriptSrc}"]`)
		if (existing) return

		const script = document.createElement('script')
		script.src = scriptSrc
		script.async = true
		document.body.appendChild(script)

		return () => {
			// Intentionally do not remove the script on unmount;
			// we want the blocker to remain active for the page lifecycle.
		}
	}, [])

	return null
}
